<template>
<div>
  <nav class="navbar-default">
    <div class="row mr-3 ml-3 pt-3 mb-3 barra">
       <div class="logo" >
        <div class="logo-img">
          <img src='static/img/background/icon_logo.png' alt="" class="">
           <img src="static/img/background/declaranet_txt.png" alt="" class="dnet-txt">
        </div>
      <h2 class=" simple-text logo-normal ml-3 m-0 ">
        <!-- {{ title }} -->

      </h2>
    </div>
      <div class="col-6 text-align-right">
        <div class="nombre">
        </div>
      </div>
    </div>
  </nav>
 <div class="card">
        <div class="card-content">
                <h4 class="card-title">Búsqueda de Servidores Públicos </h4>
                <div class="row">
                  <div class="col-md-10 espacio">
                    <div class="form-group col-md-8">
                       <label>Búsqueda por nombre o RFC:</label>
                        <div class="input-group mb-3">
                          <input type="text" class="form-control" v-model="model.busqueda" placeholder="Nombre o RFC" aria-label="Buscar:" aria-describedby="basic-addon2">
                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary" type="button" @click="busqueda">Buscar</button>
                            </div>
                        </div>
                    </div>
                  <br><br>
                  <div>
                <br>
                <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            <div class="row mt-3 mb-4" v-if="declarantes">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <b-table id="tbl_movimientos" responsive hover :items="list_funcionarios" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter" @filtered="onFiltered">
                    <!-- :fields="fields_list" -->
                    <template slot="acciones" slot-scope="row" class="actions">
                        <b-button :id="'d'+row.item.id" variant="info" size="sm" @click.prevent="declaraciones(row.item)" class="edit mr-2" >
                        <i class="fa fa-file"></i>
                        </b-button>
                    </template>
                    <template slot="empty">
                        <h5>No existen registros</h5>
                    </template>
                    </b-table>
                </div>

                <div class="col-mb-8 col-8">
                    <b-col md="6" class="my-1">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_movimientos"></b-pagination>
                    </b-col>
                </div>

                </div>



          <div class="row mt-3 mb-4" v-if="declaracionesT">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <b-table id="tbl_declaraciones" responsive hover :items="list_declaraciones" :fields="fields_list2" :per-page="perPage" :current-page="currentPage" show-empty >
                    <!-- :fields="fields_list" -->
                    <template slot="acciones" slot-scope="row" class="actions">
                        <b-button :id="'d'+row.item.id" variant="info" size="sm" @click.prevent="descargar(row.item)" class="edit mr-2" >
                        <i class="fa fa-file-pdf"></i>
                        </b-button>
                   </template>
                    <template slot="empty">
                        <h5>No existen registros</h5>
                    </template>
                    </b-table>
                </div>


           </div>


            </div>





                  </div>
                </div>





        </div>
    </div>
</div>




</template>
<script>
   import Vue from 'vue'
import {Table, TableColumn, Select, Option} from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'

import moment from 'moment'

/*   Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
 */

export default {
     components: {
       PPagination,
       [Table.name]: Table,
       [TableColumn.name]: TableColumn,
       [Select.name]: Select,
       [Option.name]: Option
     },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
     data () {
       return {
         model: {tipo_declaracion: '', dependencia_id: '', periodo: ''},
         dependencias: {},
         rol: '',
         filter: null,
         currentPage: 1,
         perPage: 10,
        // periodos:[],
         rows: null,
         declarantes: true,
         declaracionesT: false,
         tiposDeclaracion: [],
         list_funcionarios: [],
         list_declaraciones: [],
         filtro_usuarios: [],
         pagination: {
           perPage: 5,
           currentPage: 1,
           perPageOptions: [5, 10, 25, 50],
           total: 0
         },
         searchQuery: '',
         fields_list: [{
           key: 'acciones',
           label: 'Ver Declaraciones',
           thClass: 'td-small',
           tdClass: 'text-center td-small'
         },
         {
           key: 'id',
           label: 'Id',
           thClass: 'd-none',
           tdClass: 'd-none'
         }, {
           key: 'nombre',
           label: 'Nombre',
           thClass: 'td-small',
           tdClass: 'text-center td-small',
           sortable: true
         }, {
           key: 'dependencia',
           label: 'Dependencia',
           thClass: 'td-small',
           tdClass: 'text-left td-small',
           sortable: true
         }],
         fields_list2: [{
           key: 'acciones',
           label: 'Descargar',
           thClass: 'td-small',
           tdClass: 'text-center td-small'
         },
         {
           key: 'id',
           label: 'Id',
           thClass: 'd-none',
           tdClass: 'd-none'
         }, {
           key: 'dependencia',
           label: 'Dependencia',
           thClass: 'td-small',
           tdClass: 'text-left td-small',
           sortable: true
         }, {
           key: 'tipo',
           label: 'Tipo Declaración',
           thClass: 'td-small',
           tdClass: 'text-center td-small',
           sortable: true
         }, {
           key: 'fecha',
           label: 'Fecha Envío',
           thClass: 'td-small',
           tdClass: 'text-center td-small',
           sortable: true,
           formatter: value => {
             if (value) { return moment(String(value)).format('DD/MM/YYYY') } else { return '' }
           }
         }],
         propsToSearch: ['rfc', 'nombres']
       }
     },
     methods: {
       busqueda () {
         this.declaracionesT = false
         this.declarantes = true
         this.$http.get('busqueda/' + this.model.busqueda).then(
          response => {
            var v = this
            v.list_funcionarios = []
            $.each(response.data.usuarios, function (key, value) {
              v.list_funcionarios.push({
                'id': value.id,
                'nombre': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.valor
              })
            })
          },
          error => {
            this.StepError(error)
            console.log(error)
          }
        )
   },
       onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
         this.rows = filteredItems.length
         this.currentPage = 1
       },
       declaraciones (item) {
         this.declarantes = false
         this.declaracionesT = true

         this.$http.get('declaraciones/' + item.id).then(
          response => {
            var v = this
            v.list_declaraciones = []
            $.each(response.data.declaraciones, function (key, value) {
              v.list_declaraciones.push({
                'dependencia': value.declarante[0].encargo.ente.valor,
                'tipo': value.tipo_dec.tipo_declaracion,
                'fecha': value.created_at,
                'id': value.id
              })
            })
          },
          error => {
            this.StepError(error)
            console.log(error)
          }
        )
   },
       descargar (row) {
            // console.log(row)
         var url = [this.$http.options.root + 'getDeclaracion/busqueda/pdf/' + row.id]
         window.open(url, '_blank')
   }
     },
     computed: {
       pagedData () {
         return this.list_funcionarios.slice(this.from, this.to)
       },
       queriedData () {
         if (!this.searchQuery) {
           this.pagination.total = this.list_funcionarios.length
           return this.pagedData
         }
         let result = this.list_funcionarios
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
         this.pagination.total = result.length
         return result.slice(this.from, this.to)
       },
       to () {
         let highBound = this.from + this.perPage
         if (this.total < highBound) {
           highBound = this.total
         }
         return highBound
   },
       from () {
         return this.perPage * (this.currentPage - 1)
   },
       total () {
        // console.log(this.list_funcionarios.length);
         this.rows = this.list_funcionarios.length

         return this.list_funcionarios.length
   }
     }
}

</script>
<style>
  .nombre {
    padding-bottom: 0% !important;
    margin-bottom: 0% !important;
    text-align: right !important;
    margin-bottom: 5px !important;
  }

  h5,
  .h5 {
    font-size: 1.2em !important;
    margin-bottom: 5px;
  }

  .ente {
    font-size: 12px !important;
    line-height: 1em !important;
    margin-bottom: 5px !important;
  }

  .barra {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 10px !important;
    margin-top: 0 !important;
  }

  .row.mr-3.ml-3.pt-3.mb-3.barra {
    padding-top: 10px !important;
    margin-bottom: 10px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .pt-3,
  .py-3 {
    padding-top: 10px !important;
  }

  .info {
    color: white;
  }

    .logo h2 {
      font-size: 15px !important;
    }

    .sidebar .logo,
    .off-canvas-sidebar .logo {
      padding: 15px 0px !important;
      cursor: pointer
    }

    .sidebar .logo .logo-img,
    .off-canvas-sidebar .logo .logo-img {
      width: 30px !important;
      position: relative !important;
      /* margin-bottom: 8px; */
      top: -5px !important;
    }

    .sidebar .logo a.logo-mini,
    .off-canvas-sidebar .logo a.logo-mini {
      width: 50px !important;
      margin-left: 15px !important;
    }


    .dnet-txt {
      height: 40px !important;
    }

    .sidebar .logo .logo-img img,
    .off-canvas-sidebar .logo .logo-img img {
      max-width: 50px !important;
      margin-bottom: 2px !important;
    }
  .espacio{
    padding-left: 15%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Busqueda.vue